export const contentRequiredFieldsList = [
  'name',
  'picture',
  'rationale',
  'pedagogicalObjective',
  'ageRanges'
]

export const getCompletedField = (contentCompleteness, field) => {
  if (field === 'picture') return contentCompleteness.picture && contentCompleteness.thumbnail
  else return contentCompleteness[field]
}

export const getContentCompletedFields = (contentCompleteness) => {
  const completedFields = contentRequiredFieldsList.filter(field => {
    if (field === 'picture') return contentCompleteness.picture && contentCompleteness.thumbnail
    else return contentCompleteness[field]
  })
  return completedFields
}
